import React from 'react';
import { BottomSheetBackdrop as BaseBottomSheetBackdrop, } from '@gorhom/bottom-sheet';
import { useTheme } from '../../hooks';
export const BottomSheetBackdrop = ({ level = 3, ...props }) => {
    const { colors } = useTheme();
    return (React.createElement(BaseBottomSheetBackdrop, { ...props, appearsOnIndex: 0, disappearsOnIndex: -1, style: {
            zIndex: level * 1000,
            backgroundColor: colors.backgroundInverted,
        } }));
};
//# sourceMappingURL=BottomSheetBackdrop.js.map